import { useQuery } from '@tanstack/react-query';

import Client from './client';

import type { UseQueryOptions } from '@tanstack/react-query';

export const useBootStraps = (
  options: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof Client.fetchBootstraps>>>,
    'queryFn' | 'queryKey'
  > = {},
) => {
  const { data, status, error } = useQuery({
    queryKey: ['bootstraps'],
    queryFn: () => Client.fetchBootstraps(),
    refetchInterval: false,
    ...options,
  });

  return {
    bootStraps: data?.data?.data ?? null,
    getBootStrapsStatus: status,
    getBootStrapsError: error,
  };
};
